<div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{message}}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">{{ closeBtnName ? closeBtnName : 'No' }}</button>
    <button type="button" class="btn btn-danger" (click)="onSubmit()">{{ submitBtnName ? submitBtnName : 'Yes'}}</button>
</div>